import React, { useState, useEffect } from 'react'
import { Autocomplete, Box, Button, Divider, TextField } from '@mui/material'
import { RootState } from '../../../reducers'
import { useDispatch, useSelector } from 'react-redux'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { useStyles } from '../Pathologist/inboxStyles'
import { UserBannerPathologist } from '../../../interfaces/calendar'
import { Check as CheckIcon, Clear as ClearIcon } from '@mui/icons-material'
import CircularProgress from '@mui/material/CircularProgress'

export default function AmendCaseModal({ userId, open, onClose, userDetails, handleAmendCase, loading }) {
  const classes = useStyles()
  const dispatch = useDispatch()
  // const [openSuccessSnackBar, setOpenSuccessSnackBar] = useState(false)
  // const [openErrorSnackBar, setOpenErrorSnackBar] = useState(false)

  const { re_amend_success, re_amend_error } = useSelector((state: RootState) => state.amendResponse)
  const { role } = useSelector((state: RootState) => state.userLogin)
  const getUsers = useSelector((state: RootState) => state.getUsers)
  const [newUserId, setUserId] = useState(null)
  const [disableSubmit, setDisableSubmit] = useState(true)
  // const [isTranferListLoading, setTranferListLoading] = useState(true)
  const getClassNames = () => (disableSubmit ? `${classes.disableBtn} ` : `${classes.btn} ${classes.buttonMargin}`)
  const pathologists = getUsers?.data
  let activePathologists = []

  if (pathologists) {
    const filterUserResults = pathologists.filter((value) => {
      if (value.user_roles) {
        return value.user_roles == 'NL_Pathologist' && value.user_status === true
      }
    })
    activePathologists = filterUserResults.map((user) => {
      return { user_name: `${user.first_name} ${user.last_name}`, user_id: Number(`${user.user_id}`) }
    })
  }

  // useEffect(() => {
  //   if (open) {
  //     dispatch(
  //       getLabTransferList({
  //         caseUserId: userDetails?.user_id ? userDetails?.user_id : 0,
  //         id: userId,
  //         casedId: userDetails?.id,
  //       }),
  //     )
  //   }
  // }, [open])

  // useEffect(() => {
  //   setTimeout(() => setTranferListLoading(false), 4000)
  // }, [isTranferListLoading])

  const onUserIdChange = (val) => {
    if (val === null) setUserId(null)
    if (val.user_id === '') {
      setDisableSubmit(true)
    } else {
      setUserId(val.user_id)
    }
  }
  useEffect(() => {
    if (newUserId) {
      setDisableSubmit(false)
    } else {
      setDisableSubmit(true)
    }
  }, [newUserId])

  function handleCloseDialog() {
    setUserId(null)
  }

  return (
    <Box className={`${classes.mt} , ${classes.mb}`}>
      <Dialog fullWidth maxWidth="sm" id="hello" open={open} onClose={onClose} style={{ height: '750px' }}>
        <DialogTitle className={classes.dialogTitle}>Amend</DialogTitle>
        <Divider />
        <>
          <DialogContent classes={{ root: classes.dialogContentBox }} style={{ height: '165px' }}>
            <DialogContentText className={classes.dialogContent}>
              {`Select a pathologist to perform the amend to the change the Geo Location.
              A new record will be created for the amend workflow and placed in Assigned tab.`}
            </DialogContentText>
            <Autocomplete
              id="combo-box-demo"
              options={activePathologists}
              getOptionLabel={(option: UserBannerPathologist) => option?.user_name}
              isOptionEqualToValue={(option, value) => option.user_name === value.user_name}
              onChange={(e, val) => onUserIdChange(val)}
              sx={{ width: 300, marginTop: '15px' }}
              renderInput={(params) => <TextField {...params} label={`Select a pathologist`} />}
            />
            {loading && (
              <CircularProgress className={classes.loadingIndicator} style={{ width: '30px', height: '30px' }} />
            )}
          </DialogContent>
        </>

        <DialogActions className={classes.buttonActions}>
          <Button
            className={getClassNames()}
            onClick={(event) => handleAmendCase(event, userDetails?.case_id, newUserId)}
            endIcon={<CheckIcon />}
          >
            Submit
          </Button>
          <Button
            onClick={() => {
              handleCloseDialog()
              onClose()
            }}
            variant="outlined"
            className={classes.buttonMargin}
            endIcon={<ClearIcon />}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  )
}
